import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import * as Constants from './../../helpers/constants'
import UserlistPage from '../user_list_page'
import MiscellaneousApi from '../miscellaneous'
import ClearoutIndividualUserInfo from '../individual_user_info/clearout_individual_user_info'
// import ProductList from './../products/component/list'
// import CreateProduct from './../products/component/create'
import OrganizationInfo from '../org_info/org_info'
// import Coupons from '../coupons/coupons'
import OrgListPage from '../org_list_page'
// import ManageAbuse from '../abuse/manage_abuse'
// import UpdateHistory from '../update_history/abuse_update_history'
// import AbuseLogs from '../abuse_view_logs/abuse_view_logs'
import UserActivities from '../user_activities/user_activities'
import ServiceLists from '../service_list'
import MembersList from '../members_list/members_list'

const CLIENT = Constants.CLIENTS.CAMS_CLEAROUT.NAME

const clearoutCamsRouter = createBrowserRouter([
  {
    id: 'dashboard-cams-route',
    path: CLIENT,
    children: [
      {
        id: 'dashboard-cams-users',
        path: 'users',
        element: <UserlistPage />
      },
      {
        id: 'dashboard-cams-ev-list',
        path: 'email_verifier_lists',
        element: <ServiceLists service={Constants.SERVICE_TYPES.EMAIL_VERIFIER} />
      },
      {
        id: 'dashboard-cams-org-members-list',
        path: 'org_members_list',
        element: <MembersList />
      },
      {
        id: 'cams-individual-user-info',
        path: 'individual_user_info',
        element: <ClearoutIndividualUserInfo />
      },
      {
        id: 'dashboard-cams-org-users',
        path: 'org_list',
        element: <OrgListPage />
      },
      {
        id: 'dashboard-cams--user-activities',
        path: 'individual_user_activity',
        element: <UserActivities />
      },
      {
        id: 'dashboard-cams-clearout-miscellaneous-api',
        path: 'miscellaneous_api',
        element: <MiscellaneousApi />
      },
      {
        id: 'clearout-cams-organization-info',
        path: 'organization_info',
        element: <OrganizationInfo />
      },
      {
        id: CLIENT + '-redirect',
        path: '*',
        element:
          <Navigate
            to={'users'}
            replace={true}
          />
      },

    ]
  },
])

export default clearoutCamsRouter
